import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, computed} from "vue";
import lodash from "lodash";
import store from "@/bootstrap/store";
import { PickTask } from '@/stores/tasks/pick-tasks';
import {isTaskPicked} from "@/store/wavePicking/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'WavePickTask',
  props: {
  item: {
    required: true,
    type: Object as PropType<PickTask>,
  },
},
  emits: ["enableRouteLeave"],
  setup(__props, { emit }: { emit: ({
  (e: 'enableRouteLeave'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const vuexStore = store;




const lazyImageSource = ref<string>("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7")

function capitalize(value: string) {
  return lodash.capitalize(value);
}

function getLocation(item: PickTask) {
  let location = "";
  if (item.attributes.hubId !== hubId.value) {
    location += item.attributes.hubId + " - ";
  }
  location += item.attributes.location;
  return location;
}

function handleTaskClick(sku: string) {
  if(isTaskPicked(props.item)) {
    return;
  }
  emit('enableRouteLeave');
  vuexStore.dispatch('core/redirect', { name: 'wave_pick_totes', params: {sku} })
}

const hubId = computed(() => {
  return vuexStore.getters['core/getHubId'];
})


return { __sfc: true,vuexStore, emit, props, lazyImageSource, capitalize, getLocation, handleTaskClick, hubId, isTaskPicked }
}

})